import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqComponent } from './faq.component';
import { ThemeModule } from '../@theme/theme.module';
import { NbAccordionModule, NbButtonModule } from '@nebular/theme';
import { FaqLayoutComponent } from './faq.layout';
import { FaqRoutingModule } from './faq-routing.module';



@NgModule({
  declarations: [
    FaqLayoutComponent,
    FaqComponent
  ],
  imports: [
    CommonModule,
    ThemeModule,
    NbButtonModule,
    FaqRoutingModule,
    NbAccordionModule,
  ]
})
export class FaqModule { }
